import React, { useState, useEffect } from 'react';
import { FaDesktop, FaMobileAlt, FaTabletAlt } from 'react-icons/fa';
import SynioLogo from './SynioLogo';

const MobileWarning = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [deviceType, setDeviceType] = useState('');

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isSmallScreen = width < 1024 || height < 600;
      
      if (isMobileDevice || isSmallScreen) {
        setIsMobile(true);
        
        // Bestimme Gerätetyp
        if (/iPhone|iPod/i.test(navigator.userAgent)) {
          setDeviceType('Smartphone');
        } else if (/iPad/i.test(navigator.userAgent)) {
          setDeviceType('Tablet');
        } else if (/Android/i.test(navigator.userAgent)) {
          setDeviceType('Android-Gerät');
        } else {
          setDeviceType('Kleines Display');
        }
      } else {
        setIsMobile(false);
      }
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!isMobile) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-bg p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <SynioLogo height={60} />
        </div>

        {/* Warning Card */}
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-dark-border relative overflow-hidden">
          {/* Subtle top border */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-dark-border"></div>
          
          {/* Device Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="relative bg-dark-text rounded-full p-6">
                <FaMobileAlt className="text-white text-4xl" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-center text-dark-text mb-3">
            Desktop erforderlich
          </h1>

          {/* Subtitle */}
          <p className="text-center text-dark-text-secondary mb-6">
            {deviceType && (
              <span className="inline-block mb-2">
                <span className="font-semibold">{deviceType}</span> erkannt
              </span>
            )}
          </p>

          {/* Message */}
          <div className="bg-dark-hover rounded-lg p-4 mb-6 border border-dark-border">
            <p className="text-dark-text text-center leading-relaxed">
              SYNIO ist für die Verwendung auf <span className="font-semibold text-dark-text">Desktop-Computern</span> optimiert und erfordert eine größere Bildschirmauflösung für die beste Erfahrung.
            </p>
          </div>

          {/* Requirements */}
          <div className="space-y-3 mb-6">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1">
                <FaDesktop className="text-dark-text text-xl" />
              </div>
              <div>
                <p className="font-semibold text-dark-text">Desktop-Computer</p>
                <p className="text-sm text-dark-text-secondary">Mindestens 1024x600 Pixel</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1">
                <FaTabletAlt className="text-dark-text-muted text-xl" />
              </div>
              <div>
                <p className="font-semibold text-dark-text">Großer Bildschirm</p>
                <p className="text-sm text-dark-text-secondary">Für optimale Performance</p>
              </div>
            </div>
          </div>

          {/* Action */}
          <div className="bg-dark-hover rounded-lg p-4 border border-dark-border">
            <p className="text-sm text-dark-text text-center">
              <span className="font-semibold">Tipp:</span> Bitte öffnen Sie SYNIO auf einem Desktop-Computer oder Laptop für die vollständige Funktionalität.
            </p>
          </div>

          {/* Current Resolution */}
          <div className="mt-6 pt-6 border-t border-dark-border">
            <p className="text-xs text-center text-dark-text-muted">
              Aktuelle Auflösung: {window.innerWidth} × {window.innerHeight} px
            </p>
            <p className="text-xs text-center text-dark-text-muted mt-1">
              Erforderlich: Mindestens 1024 × 600 px
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-sm text-dark-text-muted">
            © SYNIO - Synthetic Data Generator
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileWarning;

